import { FC, ReactElement } from 'react'
import styled from 'styled-components'
import Candidate from 'Types/candidate.interface'
import { device } from '../breakpoints'

type CandidateCardProps = {
  candidate: Candidate
  handleSelectCandidate: (candidate: Candidate) => void
}

const CandidateCard: FC<CandidateCardProps> = ({
  candidate,
  handleSelectCandidate,
}): ReactElement => {
  return (
    <Container
      onClick={() => {
        handleSelectCandidate(candidate)
      }}
    >
      <Portrait
        style={{
          backgroundImage: `url(${candidate.photo})`,
        }}
      >
        <Group>
          <Color style={{ backgroundColor: `#${candidate.groupColor}` }} />{' '}
          {candidate.groupShortName}
        </Group>
      </Portrait>
      <Content>
        <Name>{candidate.name}</Name>
        <Infos>
          <div>
            {candidate.age} ans, {candidate.location}
          </div>
          <div>{candidate.groupName}</div>
        </Infos>
        <Quote>{candidate.quote}</Quote>
      </Content>
      <Link>
        <u>Voir la vidéo</u>
      </Link>
    </Container>
  )
}
const Container = styled.div`
  border-radius: 10px;
  height: 100%;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.backgroundColor};
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: var(--font-sans-serif);
`

const Content = styled.div`
  display: block;
  position: relative;
  z-index: 0;
  padding: 0.5em;
  background-color: ${({ theme }) => theme.backgroundColor};
  color: var(--text-color);
`
const Portrait = styled.div`
  display: block;
  position: relative;
  z-index: 1;
  border-radius: 15px;
  width: 100%;
  background-size: cover;
  background-position: center;

  &:after {
    content: '';
    display: block;
    padding-bottom: 120%;
  }
`
const Group = styled.div`
  background-color: ${({ theme }) => theme.backgroundColor};
  position: absolute;
  top: 5px;
  left: 5px;
  border-radius: 20px;
  letter-spacing: -0.01em;
  font-size: 0.65em;
  font-weight: 600;
  padding: 0 1em 0 0;
  display: inline-flex;
  align-items: center;
`
const Name = styled.div`
  font-weight: 600;
  line-height: 1.25;
  margin-top: 0.5em;
`
const Infos = styled.div`
  margin-top: 0.2em;
  font-size: 0.85em;
  line-height: 1.35em;
`
const Quote = styled.div`
  font-family: var(--font-serif);
  font-weight: 100;
  margin-bottom: 0.65em;
  margin-top: 1em;
  border-left: 4px solid #c9cad2;
  padding-left: 0.5em;
  line-height: 1.35em;
  color: var(--text-color);
  opacity: 0.5;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 0.75em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 1em;
  }
`
const Link = styled.div`
  display: inline-block;
  font-size: 0.75em;
  line-height: 1em;
  font-style: normal;
  font-size: 0.65em;
  font-weight: 600;
  text-align: center;
  padding: 1em;
  padding-bottom: 1.5em;
  background-color: ${({ theme }) => theme.backgroundColor};
  border-radius: 0px 0px 10px 10px;
  margin-top: auto;
`
const Color = styled.i`
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-left: 0.5em;
  margin-right: 0.5em;
`

export default CandidateCard
